import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60534a28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.kilimall.com/kenya/shop/store/goods/7470/2021/09/7470_06862669892121363_240.jpg.webp",
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "light" }, "After unsubscribing, you will not receive any system emails,including order logistics information", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "email-address" }, "Enter your e-mail address", -1))
const _hoisted_6 = { class: "email" }

import { onMounted, ref,inject } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import md5 from 'js-md5';
import { Toast } from 'vant'
 
export default /*#__PURE__*/_defineComponent({
  __name: 'UnSubscription',
  setup(__props) {

const route = useRoute()
 const router = useRouter()
 const subStauts = ref(false),
       subText = ref('Unsubscribe from our system emails'),
       textrdner = ref('Are you sure you want to unsubscribe?'),
       submit = ref('SUBMIT'),
       flag = ref(true),
       params = ref({
         email:route.query.email ? route.query.email : '',
         type:"UNSUBSCRIBE",
         senderId:"kilimall",
         msgType:route.query.msgType ? route.query.msgType : '800'
       })
 const $http:any = inject('$http')
       onMounted(()=>{
       let naviga = navigator.userAgent.match(
                    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
                )
        if(naviga){
          flag.value = true
        }else{
          flag.value = false
        }
       })
    
    const fn_click_submit = () => {
      let url = md5(`email=${params.value.email}&msgType=${params.value.msgType}&senderId=kilimall&type=UNSUBSCRIBEDBacVNk9s6dPjumG`)
      let data = {
        "email":params.value.email,
        "type":"UNSUBSCRIBE",
        "senderId":"kilimall",
        "sign":url,
        "msgType":params.value.msgType
      }
      $http.subscription(data).then((res:any) => {
         if(res.status === 200){
           
            let url =  process.env.NODE_ENV === "production" ?  "https://www.kilimall.co.ke/new/" : "https://www.kilitest.com/new/"
        console.log('url',url);
        
        window.location.href  = url
           Toast('You have been successfully unsubscribed')
        }else{
          Toast(res.message)
        }
        
      })
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-index", {'pc-class':!flag.value}])
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("h2", null, _toDisplayString(subText.value), 1),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(textrdner.value), 1),
          _hoisted_4
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(params.value.email), 1),
      _createElementVNode("div", {
        class: "buttom",
        onClick: fn_click_submit
      }, _toDisplayString(submit.value), 1)
    ])
  ], 2))
}
}

})